import { render, staticRenderFns } from "./formularioLibro.vue?vue&type=template&id=3b9c6b02&scoped=true"
import script from "./formularioLibro.vue?vue&type=script&lang=js"
export * from "./formularioLibro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9c6b02",
  null
  
)

export default component.exports